module.exports = __webpack_public_path__ + "static/media/icon-listen.a041b185.png";